import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove the SEO-fallback H1 (from index.html) once React mounts to avoid duplicate headings.
const seoFallback = document.getElementById("seo-fallback-h1");
if (seoFallback) seoFallback.remove();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
